import { Card, Typography, CardContent, Grid, Box, Tooltip } from '@mui/material';
import PT from 'prop-types';
import React from 'react';

//icons
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import './ResultCard.css';

const ResultCard = props => {
  const goalWPM = props.wpmGoal || props.wpmGoal == 0 ? props.wpmGoal : 25; // Static goal value for WPM
  const goalErrors = 2; // Static goal value for Errors
  const timeTaken = props?.exerciseType.startsWith('Timing')
    ? Number(props.TimeLimit) - (props.counter ?? 0)
    : props?.seconds ?? 1;
  const wordsTyped = props?.wordCount > 0 ? props.wordCount : 0;
  const wpm = Math.floor((wordsTyped * 60) / timeTaken);
  const isCompositionDrill =
    props.instanceData?.Activities.Activity.attributes.Type === 'CompositionDrill';
  return (
    <Card className="ResultCard_Card">
      <CardContent className="ResultCard_Content">
        <Typography variant="p" as="p">
          <b>Results:</b>
        </Typography>
        <Box mr={2}>
          <Grid container spacing={5}>
            {props?.instanceData?.Activities?.Activity?.attributes?.DisplayWAM === '1' ||
            props?.instanceData?.Activities?.Activity?.attributes?.DisplayWAM === 'True' ||
            props?.instanceData?.Activities?.Activity?.attributes?.DisplayWAM === 'true' ? (
              <Grid item sm={6} xs={12} md={3}>
                <Box className="ResultCard_Box">
                  <Typography className="ResultCard_BoxInfo" variant="inherit">
                    Words per Minute
                    <Tooltip title="The average WPM calculated with (word count / time taken * 60).">
                      <InfoOutlinedIcon fontSize="small" />
                    </Tooltip>
                  </Typography>
                  <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                    {/* Result */}
                    <Box textAlign="center" marginLeft="16px">
                      <Typography variant="inherit" color="black">
                        Result
                      </Typography>
                      <Typography
                        variant="inherit"
                        sx={{
                          fontWeight: 'bold',
                          color: isNaN(wpm) || wpm < goalWPM ? '#eb6060' : '#4caf50'
                        }}>
                        {isNaN(wpm) ? 0 : wpm > 0 ? wpm : 0}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ) : (
              ''
            )}

            <Grid item sm={6} xs={12} md={3}>
              <Box className="ResultCard_Box">
                <Typography className="ResultCard_BoxInfo" variant="inherit">
                  Word Count
                  <Tooltip title="The number of words typed.">
                    <InfoOutlinedIcon fontSize="small" />
                  </Tooltip>
                </Typography>
                <Typography sx={{ color: '#000000' }} align="center" variant="inherit">
                  {wordsTyped}
                </Typography>
              </Box>
            </Grid>

            <Grid item sm={6} xs={12} md={3}>
              <Box className="ResultCard_Box">
                <Typography className="ResultCard_BoxInfo" variant="inherit">
                  Time Taken
                  <Tooltip title="The total time taken to complete activity.">
                    <InfoOutlinedIcon fontSize="small" />
                  </Tooltip>
                </Typography>
                <Typography sx={{ color: '#000000' }} align="center" variant="inherit">
                  {timeTaken} Seconds
                </Typography>
              </Box>
            </Grid>
            {props?.instanceData?.Activities?.Activity?.attributes?.DisplayErrors === '1' ||
            props?.instanceData?.Activities?.Activity?.attributes?.DisplayErrors === 'True' ||
            props?.instanceData?.Activities?.Activity?.attributes?.DisplayErrors === 'true' ? (
              <Grid item sm={6} xs={12} md={3}>
                {typeof props.error === 'number' && !isCompositionDrill ? (
                  <Box className="ResultCard_Box" sx={{ marginRight: '16px' }}>
                    <Typography className="ResultCard_BoxInfo" variant="inherit">
                      Errors
                      <Tooltip title="All the incorrect words, punctuation, etc which are not the part of original exercise.">
                        <InfoOutlinedIcon fontSize="small" />
                      </Tooltip>
                    </Typography>
                    {/* Goal and Result for Errors */}
                    <Box display="flex" justifyContent="center" alignItems="center" width="100%">
                      {/* Result */}
                      <Box textAlign="center" marginLeft="16px">
                        <Typography variant="inherit" color="black">
                          Result
                        </Typography>
                        <Typography
                          variant="inherit"
                          sx={{
                            fontWeight: 'bold',
                            color: props.error <= goalErrors ? '#4caf50' : '#eb6060'
                          }}>
                          {props.error > 0 ? props.error : 0}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                ) : (
                  <></>
                )}
              </Grid>
            ) : (
              ''
            )}
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

ResultCard.propTypes = {
  seconds: PT.number,
  wordCount: PT.number,
  error: PT.number,
  userTxt: PT.array,
  orignal: PT.array,
  wpmValue: PT.number,
  TimeLimit: PT.any,
  exerciseType: PT.any,
  wpmGoal: PT.number,
  instanceData: PT.any,
  counter: PT.any
};

export default ResultCard;
